import { DatePipe, TitleCasePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { BasketService, SinglePlanPromoPriceComponent } from '@basket';
import { CatalogueService } from '@catalogue';
import { BadgeTextComponent, CardComponent, IconComponent } from '@components';
import { CustomerService } from '@customer';
import { CurrencyFormatPipe, TranslatePipe } from '@i18n';
import { PriceBandPipe } from '../../pipes/price-band/price-band.pipe';
import { MultiPlanService } from '../../services/multi-plan/multi-plan.service';

@Component({
  selector: 'app-selected-appliances',
  standalone: true,
  imports: [
    BadgeTextComponent,
    CardComponent,
    CurrencyFormatPipe,
    DatePipe,
    IconComponent,
    PriceBandPipe,
    SinglePlanPromoPriceComponent,
    TitleCasePipe,
    TranslatePipe,
  ],
  templateUrl: './selected-appliances.component.html',
  styleUrl: './selected-appliances.component.scss',
})
export class SelectedAppliancesComponent {
  private readonly basketService = inject(BasketService);
  private readonly customerService = inject(CustomerService);
  private readonly multiPlanService = inject(MultiPlanService);
  private readonly catalogueService = inject(CatalogueService);

  readonly registeredAppliance = this.basketService.initialRegisteredAppliance;
  readonly steppedFormAppliance = this.catalogueService.steppedFormAppliance();

  readonly selectedAppliances = this.multiPlanService.selectedAppliancesDetails;
  readonly startCollapsed = input<boolean>(true);
  readonly customerSelectedToPurchasePlan =
    this.customerService.customerSelectedToPurchasePlan();

  readonly total = computed(() =>
    this.basketService._showMultiPlanJourney()
      ? this.multiPlanService.total()
      : this.basketService
          .basketItemQuoteDetailsPaymentOption()
          .subsequentPayment.toFixed(2),
  );

  getMonthDate(month: number): Date {
    return new Date(2000, month - 1, 1);
  }

  readonly hasDiscountedMonths = () =>
    this.basketService.basketItemQuoteHasPromo();
}
